import { useContext, createContext } from 'react';

interface NavigationContextValue {
  navigate: (path: string) => void;
  pathname: string;
}

export const NavigationContext = createContext<NavigationContextValue | null>(
  null
);

export function useNavigate() {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('useNavigate must be used within a NavigationProvider');
  }
  return ctx.navigate;
}

export function usePathname() {
  const ctx = useContext(NavigationContext);
  if (!ctx) {
    throw new Error('usePathname must be used within a NavigationProvider');
  }
  return ctx.pathname;
}
